import React from "react";
import * as Icon from "react-bootstrap-icons";

/**
   * This is a Download Template component renderer which will render the tiles for template download.
   * @param {*} props: Template properties.
   * @returns: Download Template component.
   */
  export const TemplateDownloadRenderer = (props) => {
    console.log("TEMPLATE DOWNLOADER PROPS: ", props)
    return (
      <>
        <div className="template-download flex-row-start-center">
          <div>
            {
              props.info.extension == "xlsx"?
            <Icon.FileExcelFill fill={"#1d6f42"} width={"30px"} className="excel-template-btn" />
            :
            <Icon.FiletypePng fill={"#1d6f42"} width={"30px"} className="excel-template-btn" />
            }
            {props.info.name}
          </div>
          <a href={`${props.info.url}`} className="btn download-template-btn"><Icon.CloudDownload /></a>
        </div>
      </>
    )
  }